import { getUniTravels } from '../api/travel';

export const GET_TRAVELS = 'GET_TRAVELS';

function getTravels(travels, error=null) {
    return {
        type: GET_TRAVELS,
        travels,
        error
    }
}

export function handleGetTravels(id) {
    return async (dispatch, getState) => {
        // dispatch(showLoading())
        try {
            const result = await getUniTravels(id, getState().authedUser.token);
            if(result){
                const travels = result.data.data;
                // dispatch(hideLoading());
                return dispatch(getTravels(travels));
            } else {
                // dispatch(hideLoading())
                return dispatch(getTravels(null, "Unknown error"));
            }
        } catch (error) {
            // dispatch(hideLoading())
            return dispatch(getTravels(null, error));
        }
    }
}

// Emptying the Travels store
export function restoreTravels() {
    return async (dispatch) => {
        return dispatch(getTravels(null));
    }
}